export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9946.93bef8ad.jpg";